import View from './view'
import { useGetText } from './helpers.js'

export default function Logic(props) {
  let text = useGetText(props)

  return <View {...props} text={text} />
}
